import { create } from 'zustand';
const usePluginOutput = create(() => ({
    slots: {
        sidebar: {},
        bottom1: {},
        bottom2: {},
        bottom3: {},
        buttonstray: {},
        overlay: {},
        components: {},
    },
    plugins: [],
}));
const reactiveOutput = {
    useSlots: () => {
        return usePluginOutput((state) => state.slots);
    },
};
export class PluginlistServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setOutput(output) {
        usePluginOutput.setState(output);
    }
}
